export default "__VITE_ASSET__5c9988cb__"